import { render, staticRenderFns } from "./AvailabilityStatusDayInventoryCard.vue?vue&type=template&id=36b7c780&scoped=true&"
import script from "./AvailabilityStatusDayInventoryCard.vue?vue&type=script&lang=ts&"
export * from "./AvailabilityStatusDayInventoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./AvailabilityStatusDayInventoryCard.vue?vue&type=style&index=0&id=36b7c780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7c780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSwitch,VTextField})
